module.exports = __webpack_public_path__ + "media/images/press_kit/default/email/banner-869184bf0747e2bcc330d8a4c46107a3.jpg";